import UnauthenticatedUpcomingTripView from './UnauthenticatedUpcomingTripView';

export default UnauthenticatedUpcomingTripView;
